import {
  ActionReducer,
  MetaReducer,
  Action,
  ActionReducerMap,
} from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromRouter from '@ngrx/router-store';
import { storageMetaReducer } from '../../utils/metareducers/storage.metareducer';

/**
 * Every reducer module's default export is the reducer function itself. In
 * addition, each module should export a type or interface that describes
 * the state of the reducer plus any selector functions. The `* as`
 * notation packages up all of the exports into a single object.
 */

import { InjectionToken } from '@angular/core';
import * as fromVoucher from './voucher.reducer';
import * as fromInvite from './invite.reducer';
import * as fromMgm from './mgm.reducer';
import * as fromAuth from './auth.reducer';
import * as fromStart from './start.reducer';

/**
 * We treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
export interface State {
  [fromVoucher.featureKey]: fromVoucher.State;
  [fromInvite.featureKey]: fromInvite.State;
  [fromMgm.featureKey]: fromMgm.State;
  [fromAuth.featureKey]: fromAuth.State;
  [fromStart.featureKey]: fromStart.State;
  router: fromRouter.RouterReducerState<any>;
}

/**
 * The state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const REDUCERS = new InjectionToken<
  ActionReducerMap<State, Action>
  >('Root reducers token', {
  factory: () => ({
    [fromVoucher.featureKey]: fromVoucher.reducer,
    [fromInvite.featureKey]: fromInvite.reducer,
    [fromMgm.featureKey]: fromMgm.reducer,
    [fromAuth.featureKey]: fromAuth.reducer,
    [fromStart.featureKey]: fromStart.reducer,
    router: fromRouter.routerReducer,
  }),
});

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return (state, action) => {
    const result = reducer(state, action);
    console.groupCollapsed(action.type);
    console.log('prev state', state);
    console.log('action', action);
    console.log('next state', result);
    console.groupEnd();

    return result;
  };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
const defaultMetaReducers = [storageMetaReducer];
export const metaReducers: MetaReducer<State>[] = !environment.PRODUCTION
  ? [...defaultMetaReducers, logger]
  : [...defaultMetaReducers];
